import {
    Message,
    MessageBox,
    Loading
} from 'element-ui'
import store from '@/store/index'
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import router from '../../src/router';
import moment from 'moment';
import request from "../../src/network/request"
/**
 * @Description: LY公共组件类
 * @author Lu Jie
 * @date 2020/7/8
 */
const LYCom = {}

//#region Ajax请求

/**
 * Ajax请求配置
 * @type {{Timeout: number, ProcessData: boolean, SvrRoot: string}}
 */

LYCom.CallBizCfg = {
    // SvrRoot: 'http://192.168.2.74:7070/JsonSvc/', //业务服务地址
    // NewSvrRoot: 'http://192.168.2.74:8082/', // 2.0 服务地址
    // taskSvrRoot: 'http://192.168.2.74:8084/', // 任务模块接口
    // saveAnswerRoot: 'http://192.168.2.74:8084', //保存答题模块接口
    // FileRoot: "http://192.168.2.74:8096/", //附件服务地址
    // CounselingFileSvr: 'http://192.168.2.74:9007/JsonSvc/', // 咨询服务附件地址
    // NewSvrChat: 'ws://192.168.2.74:8082/chat', // 2.0 教师交流聊天地址
    // psychSysSvr: "http://192.168.2.74:8004/", // c端系统接口

    psychSysSvr: "https://www.lanyunxinli.com/api2/", // c端系统接口
    CounselingFileSvr: 'http://www.lanyunxinli.cn:8008/JsonSvc/', // 咨询服务附件地址
    SvrRoot: "https://www.lanyunxinli.cn/JsonSvc/", //业务服务地址
    NewSvrRoot: "https://task.bluerhyme.net/sys/", //2.0业务服务地址, //2.0业务服务地址
    NewSvrChat: 'ws://www.lanyunxinli.cn:8082/chat', // 2.0 教师交流聊天地址
    QrcodeUrl: 'https://www.lanyunxinli.cn/mobile/',
    FileRoot: 'https://www.lanyunxinli.cn/Attachment', //附件服务地址
    saveAnswerRoot: 'https://anser.bluerhyme.net/', //   保存答题模块接口
    taskSvrRoot: 'https://task.bluerhyme.net/', //  测评任务获取模块接口
    imgFileRoot: 'https://fileoss.lanyunxinli.com/', // 存阿里云附件服务地址

    ProcessData: true,
    Timeout: 200000000
}

/**
 * 格式化请求参数
 * @param arg 请求参数
 * @returns {*}
 * @constructor
 */
LYCom.FormatAjaxArg = function (arg) {
    if (arg != null && arg != undefined) {
        for (var x in arg) {
            arg[x] = JSON.stringify(arg[x])
        }
    }

    return arg
}

/**
 * 重置请求配置
 * @constructor
 */
LYCom.ResetCallBizCfg = function () {
    this.CallBizCfg.ProcessData = true
    this.CallBizCfg.Timeout = 200000000
}

/**
 * 同步请求
 * @param bizName 请求业务名
 * @param funName 请求函数名
 * @returns {*}
 * @constructor
 */
LYCom.CallBiz = function (bizName, funName) {
    var data = null
    if (arguments != null && arguments.length > 2) {
        if (this.CallBizCfg.ProcessData) {
            data = {}
            for (var i = 2, len = arguments.length; i < len; i++) {
                data['arg' + (i - 2)] = arguments[i]
            }
            data = this.FormatAjaxArg(data)
        } else {
            data = arguments[2]
        }
    }
    var rtnData = null
    $.ajax({
        url: this.CallBizCfg.SvrRoot + bizName + '.' + funName,
        type: 'POST',
        async: false,
        data: data,
        processData: this.CallBizCfg.ProcessData,
        timeout: this.CallBizCfg.Timeout,
        dataType: 'json',
        success: function (data, textStatus, jqXHR) {
            rtnData = data
        },
        error: function (xhr, textStatus) {
            if (textStatus == 'timeout') {
                throw new Error('调用超时!')
            } else {
                if (xhr.responseText == 'token失效' || xhr.responseText == 'token不能为空') {
                    MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
                        confirmButtonText: '重新登录',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        store.dispatch('FedLogOut').then(() => {
                            location.reload() // 为了重新实例化vue-router对象 避免bug
                        })
                    })
                } else {
                    throw new Error('BizSvrErr:' + xhr.responseText)
                }
            }
        }
    })
    this.ResetCallBizCfg()
    return rtnData
}

// 表情包解码
LYCom.entitiestoUtf16 = function (strObj) {
    if (!strObj) {
        return
    }
    var patt = /&#\d+;/g;
    var H, L, code;
    var arr = strObj.match(patt) || [];
    for (var i = 0; i < arr.length; i++) {
        code = arr[i];
        code = code.replace("&#", "").replace(";", "");
        H = Math.floor((code - 0x10000) / 0x400) + 0xd800; // 计算高位
        L = ((code - 0x10000) % 0x400) + 0xdc00; // 计算低位
        code = "&#" + code + ";";
        var s = String.fromCharCode(H, L);
        strObj = strObj.replace(code, s);
    }
    return strObj;
},
    LYCom.utf16toEntities = function (str) {
        if (!str) return
        var patt = /[\ud800-\udbff][\udc00-\udfff]/g; // 检测utf16字符正则
        str = str.replace(patt, function (char) {
            var H, L, code;
            if (char.length === 2) {
                H = char.charCodeAt(0); // 取出高位
                L = char.charCodeAt(1); // 取出低位
                code = (H - 0xD800) * 0x400 + 0x10000 + L - 0xDC00; // 转换算法
                return "&#" + code + ";";
            } else {
                return char;
            }
        });
        return str;
    },
    /**
     * 异步请求
     * @param onAsynCallBack 回调函数
     * @param bizName 请求地址
     * @constructor
     */
    LYCom.AsynCallBiz = function (onAsynCallBack, bizName) {
        var data = null
        if (arguments != null && arguments.length > 2) {
            if (this.CallBizCfg.ProcessData) {
                data = {}
                for (var i = 2, len = arguments.length; i < len; i++) {
                    data['arg' + (i - 2)] = arguments[i]
                }
                data = this.FormatAjaxArg(data);

            } else {
                data = arguments[2]
            }
        }
        $.ajax({
            url: this.CallBizCfg.SvrRoot + bizName,
            type: 'POST',
            async: true,
            data: data,
            processData: this.CallBizCfg.ProcessData,
            timeout: this.CallBizCfg.Timeout,
            dataType: 'json',
            success: function (data, textStatus, jqXHR) {
                onAsynCallBack({
                    rtnObj: data
                })
            },
            error: function (xhr, textStatus) {
                if (textStatus == 'timeout') {
                    onAsynCallBack({
                        err: '调用超时!'
                    })
                } else {
                    if (xhr.responseText == 'token失效' || xhr.responseText == 'token不能为空') {
                        MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
                            confirmButtonText: '重新登录',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            store.dispatch('FedLogOut').then(() => {
                                location.reload() // 为了重新实例化vue-router对象 避免bug
                            })
                        })
                    } else {
                        onAsynCallBack({
                            err: 'BizSvrErr:' + xhr.responseText
                        })
                    }

                }
            }
        })
        this.ResetCallBizCfg()
    }

// LYCom.AsynCallBizPoll = function(onAsynCallBack, bizName) {
//     var data = null;
//     if (arguments != null && arguments.length > 2) {
//         if (this.CallBizCfg.ProcessData) {
//             data = {};
//             for (var i = 2, len = arguments.length; i < len; i++) {
//                 data["arg" + (i - 2)] = arguments[i];
//             }
//             data = this.FormatAjaxArg(data);
//         } else {
//             data = arguments[2];
//         }
//     }
//     $.ajax({
//         url: this.CallBizCfg.SvrRoot + bizName,
//         type: 'POST',
//         async: true,
//         data: data,
//         processData: this.CallBizCfg.ProcessData,
//         timeout: this.CallBizCfg.Timeout,
//         dataType: 'json',
//         success: function(data, textStatus, jqXHR) {
//             onAsynCallBack({ rtnObj: data });
//         },
//         error: function(xhr, textStatus) {
//             if (textStatus == "timeout") {
//                 onAsynCallBack({ err: "调用超时!" });
//             } else {
//                 if (xhr.responseText == "token失效") {
//                     MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
//                         confirmButtonText: '重新登录',
//                         cancelButtonText: '取消',
//                         type: 'warning'
//                     }).then(() => {
//                         store.dispatch('FedLogOut').then(() => {
//                             location.reload() // 为了重新实例化vue-router对象 避免bug
//                         })
//                     })
//                 } else {
//                     onAsynCallBack({ err: "BizSvrErr:" + xhr.responseText });
//                 }
//             }
//         }
//     })
//     this.ResetCallBizCfg();
// }

//#endregion

//#region Token管理

const TokenKey = 'token'

/**
 * 获取Token
 * @constructor
 */
LYCom.GetToken = function () {
    return sessionStorage.getItem(TokenKey)
}
// 获取2.0版本token
LYCom.GetLYToken = function () {
    return window.sessionStorage.getItem("LyToken");
},

    /**
     * 保存Token
     * @param token 令牌
     * @constructor
     */
    LYCom.SetToken = function (token) {
        sessionStorage.setItem(TokenKey, token)
    }

/**
 * 移除Token
 * @constructor
 */
LYCom.RemoveToken = function () {
    sessionStorage.removeItem(TokenKey)
}

//#endregion

//#region 树形结构方法

/**
 * 递归查询数据
 * @param arr 源数据
 * @param child 子节点标识
 * @param fn 判断回调
 * @param result 结果
 * @constructor
 */
LYCom.Find = function (arr, child, fn, result) {
    if (arr && arr.length) {
        arr.forEach(item => {
            if (fn(item)) {
                result.push(item)
            } else {
                if (item[child] && item[child] != null && item[child].length > 0) {
                    LYCom.Find(item.children, child, fn, result)
                }
            }
        })
    }
}

// LYCom.GetTree = function(data, parentId, pTag) {
//     let result = [];
//     data.forEach((item, index) => {
//         if(item[pTag] === parentId) {
//             result.push(item);
//             LYCom.ConvertChildren(data, item, item.id);
//         }
//     })
// }
//
// LYCom.ConvertChildren = function(arr, parent, parentId) {
//
// }

//#endregion

//#region 字符串

/**
 * 判断字符串是否为空
 * @param str 字符串
 * @returns {boolean} 是否为空
 * @constructor
 */
LYCom.StringIsEmpty = function (str) {
    if (typeof str == null || str == '' || str == 'undefined') {
        return true
    } else {
        return false
    }
}

//#endregion

//#region 身份证

/**
 * 身份证号合法性验证
 * 支持地址编码、出生日期、校验位验证
 * @param code 身份证号码
 * @returns {boolean} 是否合法
 * @constructor
 */
LYCom.IdentityCodeValid = function (code) {
    var city = {
        11: '北京',
        12: '天津',
        13: '河北',
        14: '山西',
        15: '内蒙古',
        21: '辽宁',
        22: '吉林',
        23: '黑龙江 ',
        31: '上海',
        32: '江苏',
        33: '浙江',
        34: '安徽',
        35: '福建',
        36: '江西',
        37: '山东',
        41: '河南',
        42: '湖北 ',
        43: '湖南',
        44: '广东',
        45: '广西',
        46: '海南',
        50: '重庆',
        51: '四川',
        52: '贵州',
        53: '云南',
        54: '西藏 ',
        61: '陕西',
        62: '甘肃',
        63: '青海',
        64: '宁夏',
        65: '新疆',
        71: '台湾',
        81: '香港',
        82: '澳门',
        91: '国外 '
    }
    var tip = ''
    var pass = true

    //验证身份证格式（6个地区编码，8位出生日期，3位顺序号，1位校验位）
    if (!code || !/^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/i.test(code)) {

        tip = '身份证号格式错误'
        pass = false
    } else if (!city[code.substr(0, 2)]) {
        tip = '地址编码错误'
        pass = false
    }
    //  else {
    //     //18位身份证需要验证最后一位校验位
    //     if (code.length == 18) {
    //         code = code.split('')
    //             //加权因子
    //         var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
    //             //校验位
    //         var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
    //         var sum = 0
    //         var ai = 0
    //         var wi = 0
    //         for (var i = 0; i < 17; i++) {
    //             ai = code[i]
    //             wi = factor[i]
    //             sum += ai * wi
    //         }
    //         var last = parity[sum % 11]
    //         if (last != code[17]) {
    //             tip = '校验位错误'
    //             pass = false
    //         }
    //     }
    // }

    return pass
}

/**
 * 根据身份证号码获取出生日期
 * @param idCard 身份证号码
 * @returns {string} 出生日期
 * @constructor
 */
LYCom.GetBirthdayByIdCard = function (idCard) {
    var birthday = ''
    if (idCard != null && idCard != '') {
        if (idCard.length == 15) {
            birthday = '19' + idCard.substr(6, 6)
        } else if (idCard.length == 18) {
            birthday = idCard.substr(6, 8)
        }

        birthday = birthday.replace(/(.{4})(.{2})/, '$1-$2-')
    }

    return birthday
}


//时间格式化
LYCom.formatTime = function (value) {
    if (value == undefined) {
        value = 0;
    }
    let second = Math.abs(parseInt(value)); // 秒
    let min = 0; // 分
    let hour = 0; // 小时
    if (second >= 60) {
        min = parseInt(second / 60);
        second = parseInt(second % 60);
        if (min >= 60) {
            hour = parseInt(min / 60);
            min = parseInt(min % 60);
        }
    }
    let result = "";
    if (second >= 0) {
        result += parseInt(second) + "秒"
    }
    if (min == 0 && hour == 0 && second == 0) {
        result = "";
    }
    if (min > 0) {
        result = "" + parseInt(min) + "分钟" + result;
    }
    if (hour > 0) {
        result = "" + parseInt(hour) + "小时" + result;
    }
    return result;
}




/**
 * 根据身份证号码获取年龄
 * @param identityCard 身份证号码
 * @returns {number} 年龄
 * @constructor
 */

LYCom.GetAgeByIdCard = function (identityCard) {
    var strBirthday = LYCom.GetBirthdayByIdCard(identityCard)
    if (strBirthday == '') {
        return 0
    }

    //时间字符串里，必须是“/”
    var birthDate = new Date(strBirthday)
    var nowDateTime = new Date()
    var age = nowDateTime.getFullYear() - birthDate.getFullYear()
    //再考虑月、天的因素;.getMonth()获取的是从0开始的，这里进行比较，不需要加1
    if (nowDateTime.getMonth() < birthDate.getMonth() || (nowDateTime.getMonth() == birthDate.getMonth() && nowDateTime.getDate() < birthDate.getDate())) {
        age--
    }

    return age
}

/**
 * 根据身份证号获取性别
 * @param idCard 身份证号码
 * @returns {number} 性别（1：男；2：女）
 * @constructor
 */
LYCom.GetSexByIdCard = function (idCard) {
    if (LYCom.StringIsEmpty(idCard)) {
        return -1
    }

    if (parseInt(idCard.substr(16, 1)) % 2 == 1) {
        return 1
    } else {
        return 2
    }
}

//#endregion

//#region 时间转化

/**
 * 格式化时间
 * @param date 时间
 * @param fmt 格式化字符串
 * @returns {*} 格式化时间
 */
LYCom.FormatDate = function (date, fmt) {
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
    }
    for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            let str = o[k] + ''
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str))
        }
    }
    return fmt
}

//#endregion

/**
 * 时间格式化
 * @param fmt
 * @returns {*}
 */
Date.prototype.format = function (fmt) {
    var o = {
        'M+': this.getMonth() + 1, //月份
        'd+': this.getDate(), //日
        'h+': this.getHours(), //小时
        'm+': this.getMinutes(), //分
        's+': this.getSeconds(), //秒
        'q+': Math.floor((this.getMonth() + 3) / 3), //季度
        'S': this.getMilliseconds() //毫秒
    }
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
        }
    }
    return fmt
}

//#region 学校相关计算

/**
 * 获取当前学年
 * @returns {number} 当前学年
 */
LYCom.GetCurrentSchoolYear = function () {
    let date = new Date()
    let year = date.getFullYear(),
        month = date.getMonth()

    if (month >= 8) {
        return year
    }
    return year - 1
}

//#endregion

//#region

LYCom.MMPTDegreeColorArr = ['#c0392b', '#d35400', '#f5d03e', '#3bafda', '#8CC152']

LYCom.GetMMPTDegreeColor = function (degree, description) {
    if (degree == 1) {
        return LYCom.MMPTDegreeColorArr[0]
    } else if (degree == 5) {
        return LYCom.MMPTDegreeColorArr[4]
    }
    if (description) {
        if (description.indexOf('轻') !== -1 || description.indexOf('较为正常') !== -1 || description.indexOf('可能存在心理问题') !== -1) {
            return LYCom.MMPTDegreeColorArr[3]
        } else if (description.indexOf('中') !== -1) {
            return LYCom.MMPTDegreeColorArr[2]
        } else if (description.indexOf('重') !== -1) {
            return LYCom.MMPTDegreeColorArr[0]
        } else if (description.indexOf('无') !== -1 || description.indexOf('正常') !== -1) {
            return LYCom.MMPTDegreeColorArr[4]
        }
    }
    return LYCom.MMPTDegreeColorArr[degree - 1]
}
// 临时修改后面整顿
LYCom.MMPTDegreeColorArr2 = ['#c0392b', '#9e51b7', '#e49621', '#3bafda', '#8cc152', '#8a8a8a'] // 重度=>中重度=> 中度=> 轻度=> 健康、正常、无=>无效
LYCom.GetMMPTDegreeColor2 = function (degree, description) {

    // if (degree == 1) {
    //     return LYCom.MMPTDegreeColorArr2[0]
    // } else if (degree == 5) {
    //     return LYCom.MMPTDegreeColorArr2[4]
    // }
    if (description) {
        if ((description.indexOf('无') !== -1 && description.indexOf('无效') == -1) || description.indexOf('正常') !== -1) {
            return LYCom.MMPTDegreeColorArr2[4]
        } else if (description.indexOf('轻') !== -1 || description.indexOf('轻度') !== -1 || description.indexOf('轻微') !== -1) {
            return LYCom.MMPTDegreeColorArr2[3]
        } else if (description.indexOf('中度') !== -1) {
            return LYCom.MMPTDegreeColorArr2[2]
        } else if (description.indexOf('中重度') !== -1) {
            return LYCom.MMPTDegreeColorArr2[1]
        } else if (description.indexOf('重度') !== -1) {
            return LYCom.MMPTDegreeColorArr2[0]

        } else if (description.indexOf('无效') !== -1) {
            return LYCom.MMPTDegreeColorArr2[5]
        }
    }
    return LYCom.MMPTDegreeColorArr2[degree - 1]
}


// 通过程度获取访谈程度背景颜色
LYCom.GetDegreeColor = function (degree) {
    return LYCom.MMPTDegreeColorArr[5 - degree]
}
// 通过程度获取程度名字
LYCom.GetDegreeName = function (degree) {
    switch (degree) {
        case 1:
            return '无明显表现';
            break;
        case 2:
            return '轻度关注';
            break;
        case 3:
            return '中度关注';
            break;
        case 4:
            return '重点关注';
            break;
        default:
            return '特别关注'
            break;
    }
},

    //#endregino
    // base64 转二进制流
    LYCom.Base64toBlob = function (base64, type) {
        // 将base64转为Unicode规则编码
        let bstr = atob(base64, type),
            n = bstr.length,
            u8arr = new Uint8Array(n)
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n) // 转换编码后才可以使用charCodeAt 找到Unicode编码
        }
        return new Blob([u8arr], {
            type,
        })
    }
//图片格式转换方法
LYCom.dataURLToBlob = function (dataurl) {
    let arr = dataurl.split(",");
    let mime = arr[0].match(/:(.*?);/)[1];
    let bstr = atob(arr[1]);
    let n = bstr.length;
    let u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], {
        type: mime
    });
},
    // 文字导出text文件
    LYCom.exportText = function (filename, exportInfo) {
        let exportTxt = `该Excel共${exportInfo.failedNum + exportInfo.successNum}条数据，成功录入条数：${exportInfo.successNum}条，异常条数：${exportInfo.failedNum} 条\n`
        if (exportInfo && exportInfo.failedList && exportInfo.failedList.length) {
            exportInfo.failedList.forEach(item => {
                exportTxt += `第${item.index}行数据异常  [${item.name ? item.name : ''}] [${item.idcard ? item.idcard : ''}] 异常原因：${item.cause ? item.cause : ''} \n`
            });
        }
        var element = document.createElement("a");
        element.setAttribute(
            "href",
            "data:text/plain;charset=utf-8," + encodeURIComponent(exportTxt)
        );
        element.setAttribute("download", filename);

        element.style.display = "none";
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
    },
    // html转图片下载
    LYCom.exportImg = function (fileName) {
        let a = document.createElement("a");
        html2canvas(document.querySelector("#printDom"), {

            useCORS: true,
        }).then((canvas) => {
            let dom = document.body.appendChild(canvas);
            dom.style.display = "none";
            a.style.display = "none";
            document.body.removeChild(dom);
            let blob = LYCom.dataURLToBlob(dom.toDataURL("image/png"));
            a.setAttribute("href", URL.createObjectURL(blob));
            //这块是保存图片操作  可以设置保存的图片的信息
            a.setAttribute("download", fileName + ".png");
            document.body.appendChild(a);
            a.click();
            URL.revokeObjectURL(blob);
            document.body.removeChild(a);
        });
    }

// html转pdf下载
LYCom.exportPdf = function (fileName) {
    let a = document.createElement("a");
    html2canvas(document.querySelector("#printDom"), {
        scale: 1,
        useCORS: true,
    }).then((canvas) => {
        let dom = document.body.appendChild(canvas);
        dom.style.display = "none";
        a.style.display = "none";
        var contentWidth = canvas.width - 20;
        var contentHeight = canvas.height;
        //一页pdf显示html页面生成的canvas高度;
        var pageHeight = (contentWidth / 572.28) * 821.89;
        //未生成pdf的html页面高度
        var leftHeight = contentHeight;
        //页面偏移
        var position = 20;
        //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
        var imgWidth = 557.28;
        var imgHeight = (572.28 / contentWidth) * contentHeight;

        var pageData = canvas.toDataURL("image/JPEG", 1.0);

        var pdf = new jsPDF("", "pt", "a4");

        //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
        //当内容未超过pdf一页显示的范围，无需分页
        if (leftHeight < pageHeight) {
            pdf.addImage(pageData, "JPEG", 20, 20, imgWidth, imgHeight);
        } else {
            while (leftHeight > 0) {
                pdf.addImage(pageData, "JPEG", 20, position, imgWidth, imgHeight);
                leftHeight -= pageHeight;
                position -= 841.89;
                //避免添加空白页
                if (leftHeight > 0) {
                    pdf.addPage();
                }
            }
        }
        pdf.save(fileName + ".pdf");
    });
}

// 获取统计图颜色
LYCom.getColor = function (des) {
    let color = ["#ff695e", "#5de257", "#5eccfc", "#38362f", "#c23531", "#d35400"];
    if (des) {
        if (des.indexOf("关注") != -1 || des.indexOf("重度") != -1) {
            return color[0];
        } else if (
            des.indexOf("健康") != -1 ||
            des.indexOf("有效") != -1 ||
            (des == '无' && des.indexOf("无") != -1)
        ) {
            return color[1];
        } else if (des.indexOf("正常") != -1 || des.indexOf("轻度") != -1) {
            return color[2];
        } else if (des.indexOf("无效") != -1) {
            return color[3];
        } else if (des.indexOf("中度") != -1) {
            return color[5];
        } else if (des.indexOf("严重") != -1) {
            return color[4];
        }
    }
}
// 配置量表分类下拉树结构
LYCom.sideTreeNormalizer = function (node) {
    if (node.Children && node.Children != null && node.Children.length > 0) {
        return {
            id: node.Code,
            label: node.Name,
            children: node.Children,
        };
    } else {
        return {
            id: node.Code,
            label: node.Name,
            Children: delete node.Children,
        };
    }
},
    // 学校组织机构 --树形节点配置
    LYCom.schoolOrgNormalizer = function (node) {
        if (node.children && node.children != null && node.children.length > 0) {
            return {
                id: node.id,
                label: node.name,
                children: node.children,
            };
        } else {
            return {
                id: node.id,
                label: node.name,
                Children: delete node.children,
            };
        }
    },
    //跳转学生详情
    LYCom.toStudentDetail = function (curStudentRow, currPageNo, currActiveName, taskPageInfo = null) {
        // curStudentRow：当前学生信息, currPageNo：当前分页页码,currActiveName：当前页面分类 taskPageInfo：任务信息（分页和当前任务信息）
        window.sessionStorage.setItem('curStudentRow', JSON.stringify(curStudentRow))

        router.push({
            name: 'studentDetail',
            query: {
                currPageNo: currPageNo,
                currActiveName: currActiveName,
                taskPageInfo: taskPageInfo
            }
        })
    },
    LYCom.filterScaleName = function (name) {

        if (name) {
            if (name.indexOf('中学生心理健康综合测量') != -1) {
                return '中小学生成长问卷-112'
            } else if (name.indexOf('中学生心理健康量表') != -1) {
                return "中小学生成长问卷-80"
            } else if (name.indexOf('症状自评量表') != -1) {
                return "中小学生成长问卷-110"
            } else if (name.indexOf('小学生心理健康评定量表') != -1) {
                return "中小学生健康成长问卷-80"
            } else {
                return name
            }
        } else {
            return ''
        }

    },
    // 获取性别中文名称
    LYCom.getSexName = function (sex) {
        if (sex == 1) {
            return "男"
        } else if (sex == 2) {
            return '女'
        } else {
            return ''
        }
    },
    // 重点学生解决方式中文名称
    LYCom.getSolveMethodName = function (type) {
        if (type == 1) {
            return "复核测评"
        } else if (type == 2 || type == 3) {
            return '心理访谈'
        } else if (type == 4) {
            return "手动取消"
        } else {
            return ''
        }
    },
    // 时间格式化
    LYCom.getTime = function (date, format = 'YYYY-MM-DD') {
        if (date) {
            return moment(date).format(format);
        } else {
            return ""
        }

    },
    /*
        通过角色组判断当前筛选条件是否显示 
        orgLevel: 1.教育厅 2.市教委 3.教育局 4. 学校  5.年级班级专业
        currentRoleGroup:1.系统管理员 2.教育局 3.学校/心理老师  10.教育厅 11.市教委
    */
    LYCom.getDisplayByRoleGroup = function (currentRoleGroup, orgLevel) {
        // 教育厅
        if (orgLevel == 1) {
            if (currentRoleGroup == 1) {
                return true
            } else {
                return false
            }
        }
        // 市教委
        else if (orgLevel == 2) {
            if (currentRoleGroup == 1 || currentRoleGroup == 10) {
                return true
            } else {
                return false
            }

        }
        // 教育局
        else if (orgLevel == 3) {
            if (currentRoleGroup == 10 || currentRoleGroup == 11) {
                return true
            } else {
                return false
            }
        }
        // 学校
        else if (orgLevel == 4) {
            if (currentRoleGroup == 11 || currentRoleGroup == 2) {
                return true
            } else {
                return false
            }
        }
        // 年级    
        else if (orgLevel == 5) {
            if (currentRoleGroup == 3 || currentRoleGroup == 2) {
                return true
            } else {
                return false
            }
        } else if (orgLevel == 6) {
            if (currentRoleGroup == 3) {
                return true
            } else {
                return false
            }
        }
    },
    // 通过组织机构组判断是否显示教育局栏
    LYCom.getDisplayEducation = function (currentRoleGroup) {
        if (currentRoleGroup == 3 || currentRoleGroup == 2) {

        } else {
            return true
        }
    },
    LYCom.addressFormat = function (row) {
        return (row.areaName ? row.areaName : '') + (row.address ? row.address : '')
    },
    LYCom.uploadHearders = function () {
        let headers = {
            "Authorization": window.sessionStorage.getItem("LyToken")

        }
        return headers
    },
    // 通过任务类型获取任务类型名称
    LYCom.getTaskTypeName = function (type) {
        if (type == 1) {
            return '心理测评任务'
        } else if (type == 2) {
            return '心理训练任务'
        } else if (type == 3) {
            return '心理教学任务'
        }
    },
    // 通过任务状态获取状态名称
    LYCom.getTaskStatusName = function (status) {
        if (status == 2) {
            return '执行中'
        } else if (status == 4) {
            return '已完成'
        } else if (status == -2) {
            return '已结束'
        }
    },
    //导出量表答题记录
    LYCom.exportScaleAnser = function (mmptRecordId) {
        mmptRecordId=18758603
        if (!mmptRecordId) return Message.info('暂无测评记录！')
        const loading = Loading.service({
            lock: true,
            text: '答题记录导出中，请耐心等待...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        })
        request
            .post("/educationadmin/taskInfo/downAnswerRecord",)
            .then((res) => {

            })
            .catch((err) => {
                loading.close();
                Message.error("导出失败：" + err.msg);
            });

    },
    // 获取答题选项序号
    LYCom.getOptionSerialNo = function (index) {
        switch (index) {
            case 0:
                return 'A';

            case 1:
                return 'B';

            case 2:
                return 'C';

            case 3:
                return 'D';

            case 4:
                return 'E';

            case 5:
                return 'F';

            case 6:
                return 'G';
            case 7:
                return 'H';
            case 8:
                return 'J';
            case 9:
                return 'K';


        }
    }


// LYCom.getPageInfo = function(currPage, activeName) {
//     let pageInfo = window.sessionStorage.getItem('pageInfo'); // 获取跳转学生详情页面分页参数
//     if (pageInfo) {
//         pageInfo = JSON.parse(pageInfo)
//         let obj = {
//             CurrPageNo: pageInfo.currPageNo
//         }

//         if (pageInfo.currActiveName) {
//             obj.activeName = pageInfo.currActiveName + ''
//         }
//         window.sessionStorage.removeItem('pageInfo')
//         return obj
//     }
// }


export default LYCom



//////////////////
// WEBPACK FOOTER
// ./static/js/LYCom.js
// module id = ZDvl
// module chunks = 99